import { Component, EventEmitter, Inject, Input, OnInit, Output } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from "@azure/msal-angular";
import { AuthenticationResult, BrowserUtils, InteractionStatus, PopupRequest } from "@azure/msal-browser";
import { Subject } from "rxjs";
import { Location } from "@angular/common";
import { filter, takeUntil } from "rxjs/operators";
import { ApiCall } from "@shared/async-services/http/api-call.service";
import { BroadCastServiceService } from "@shared/services/broad-cast-service.service";
import storageService from "@shared/storage/storageService";
import { environment } from "@env/environment";
import { FormGroup } from "@angular/forms";


export interface DialogData {
  periodicSubTitle: any;
  annualEvaluation : any
  annualSubtitle : any;
  event: boolean;
  title: string;
  message: string;
  tempdata: any;
  custIdentifyData : any
  periodicEvalution : any
  titleId : any
}

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent implements OnInit {
  email : any
  dialogData: DialogData;
  event: boolean;
  exchangeData: boolean = true;
  title:string;
  message:string;
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  currentUser: any;
  canSyncOutlookData = false;
  loadFirstTime = false;
  outlookSync: boolean = false;
  loadFirstTimeII = false;
  userExchangeUserName: any;
  userExchangePassword: any;
  userOutlookUsername : any;
  userOutlookPassword: any;
  @Output() myServiceEvent : EventEmitter<any> = new EventEmitter();

  constructor(
      public dialogRef: MatDialogRef<ConfirmDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: DialogData,
      @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
      private authService: MsalService,
      private msalBroadcastService: MsalBroadcastService,
      private location: Location,
      private apiCall: ApiCall,
      private broadCast: BroadCastServiceService,
      public dialog: MatDialog,

              ) {}

  ngOnInit() {
    this.currentUser = storageService.getItemAsJSON("currentUser");
    const currentPath = this.location;
    this.setUserCalendarAccounts();
    // Dont perform nav if in iframe or popup, other than for front-channel logout
    // this.isIframe = BrowserUtils.isInIframe() && !window.opener && currentPath.indexOf("logout") < 0; // Remove this line to use Angular Universal
    this.setLoginDisplay();
    
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      })
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }
  onConfirm(): void {
     // Close the dialog, return true
     this.dialogRef.close(true);
     if(this.data.event) {
      if(this.currentUser.calendarChoice !== 'MS_EXCHANGE') {
        let activeAccount;
        this.msalBroadcastService.inProgress$
        .pipe(
          filter((status: InteractionStatus) => status === InteractionStatus.None),
          takeUntil(this._destroying$)
        )
        .subscribe(() => {
        activeAccount = this.authService.instance.getAllAccounts().length > 0;
        });
      if (!activeAccount){
           this.authService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest)
             .subscribe((response: AuthenticationResult) => {
               this.authService.instance.setActiveAccount(response.account);
               this.apiCall.setOutlookTokens(response.accessToken, response.idToken, response.tokenType);
               if(this.data.tempdata) {
                if(this.currentUser.calendarChoice !== 'MS_EXCHANGE') {
                 let outlookRequest = this.convertBookedSlotToOutlookEvent(this.data.tempdata);
                 this.createSameEventOnOutlookCalendar(outlookRequest);
                }
               }
               this.myServiceEvent.emit({message : 'confirm'});
               this.broadCast.getMessage().subscribe((message) => {
                 if (message && !this.loadFirstTime) {
                   this.loadFirstTime = true;
                   if(message  == 'chief-account'){
                     this.broadCast.sendMessage("outlook-data-display-ca");
                   }else{
                     this.broadCast.sendMessage("outlook-data-display");
                   }
                 }
               });
   
             },(err) => {
               console.log(err);
             });
           } else {
                 this.authService.instance.setActiveAccount(this.authService.instance.getActiveAccount());
                 this.myServiceEvent.emit({message : 'confirm'});
                 this.broadCast.getMessage().subscribe((message) => {
                   if (message && !this.loadFirstTimeII) {
                     this.loadFirstTimeII = true;
                     if(message  == 'chief-account' ){
                       this.broadCast.sendMessage("outlook-data-display-ca");
                     }else{
                       this.broadCast.sendMessage("outlook-data-display");
                     }               
                   }
                 });
            
         }
       } else {
        if(this.data.tempdata) {
        this.createBookingSlotsForExchange(this.data.tempdata); 
        }
       }
      }
 }

 setUserCalendarAccounts(){
  if(this.currentUser?.userCalendarAccounts !== undefined){
    this.currentUser?.userCalendarAccounts.forEach(userCalendarAccount => {
      if(userCalendarAccount.accountType == "MS_EXCHANGE"){
        this.userExchangeUserName = userCalendarAccount.accountEmail;
        this.userExchangePassword = userCalendarAccount.accountPassword;
      }
      if(userCalendarAccount.accountType == "MS_OUTLOOK"){
        this.userOutlookUsername = userCalendarAccount.accountEmail;
        this.userOutlookPassword = userCalendarAccount.accountPassword;
      }
    });
  }
}

  createSameEventOnOutlookCalendar(data) {
    this.apiCall.createOutlookSlot(data).subscribe((res) => {
      console.log("convertVenaqiSlotToOutlookEvent: ", res);
    });
  }

  createBookingSlotsForExchange(data){
    if(data){
      let exchangeLoginRequest = {
        "exchangeUsername" : this.userExchangeUserName,
        "exchangePassword" : this.userExchangePassword
      };
      this.apiCall.doExchangeLogin(exchangeLoginRequest).subscribe(
        (res: any) => {
          storageService.setItemAsJSON("exchangeUser", res);
          if(res.status == "SUCCESS"){
            let bookedSlot = data.bookingSlot;
              let requestBody = {
                "exchangeUsername" : this.userExchangeUserName,
                "exchangePassword" : this.userExchangePassword,
                "appointmentStartDate" : bookedSlot.slotStartTime,
                "appointmentEndDate" : bookedSlot.slotEndTime,
                "appintmentURL" : bookedSlot.accountantBookingSlot.meetingLink,
                "appointmentSubject" : bookedSlot.accountantBookingSlot.subject,
                "appointmentBody" : bookedSlot.description,
              };
              this.apiCall.createExchangeAppointments(requestBody).subscribe((res) => {
                  console.log("Exchange =====", res)
              });
          }else {
            //this.showSpinner=false;
            // this.toastr.error("Wrong credentials, Please try again.", "");
          }
  
        },
        (err: any) => {
          //this.showSpinner=false;
          console.log("Something went wrong");
        }
      );
      
    }
}

  convertBookedSlotToOutlookEvent(data) {
    try {
      let bookedSlot = data.bookingSlot;

      let subject = data.user.fullName
      let slotStartTime = bookedSlot.slotStartTime;
      let slotEndTime = bookedSlot.slotEndTime;
    
      let bookingSlot = {
        "subject": subject,
        "start": {
          "dateTime": slotStartTime,
          "timeZone": "UTC"
        },
        "end": {
          "dateTime": slotEndTime,
          "timeZone": "UTC"
        },
        "reminderMinutesBeforeStart": environment.REMINDER_MINUTES_BEFORE_START
      };

      return bookingSlot
    } catch (error) {
      console.error("Error while preparing outlook request body, ", error);
    }
  }
  
  cancel(): void {
      // Close the dialog, return false
      this.dialogRef.close(false);
  }
}
